var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { useFetch, usePromise, useRouting } from '@rad/hooks';
import Link from '@rad/components/utility/link';
import { expand } from '@rad/utility/validation';
import AdminPageLayout from '../../../../layout/admin-page-layout';
import AnnouncementAddEdit from './announcement-form-add-edit';
import { getAnnouncement, createAnnouncement, updateAnnouncement } from '../../../../common/network/announcement';
import { createState } from './../../../../types/announcement';
import { adminRoutes } from '../../../../common/routes/admin';
import { useToast } from '../../../../contexts/toast';
const AdminContentAnnouncementsAddEdit = (props) => {
    var _a;
    const [, navigate] = useRouting();
    const toast = useToast();
    const defaultAnnouncement = React.useMemo(createState, []);
    const [announcementPromise] = useFetch(getAnnouncement(props.id));
    const announcement = (_a = usePromise(announcementPromise)) !== null && _a !== void 0 ? _a : defaultAnnouncement;
    const [formState, setForm] = React.useState(createState());
    const goToAnnouncements = React.useCallback(() => navigate(adminRoutes.contentAnnouncements.getURL()), [navigate]);
    const [errors, setErrors] = React.useState({});
    const submit = () => __awaiter(void 0, void 0, void 0, function* () {
        setErrors({});
        const [result, errors] = props.id ? (yield updateAnnouncement(formState)) : (yield createAnnouncement(formState));
        if (result) {
            toast.success(props.id ? 'Announcement updated' : 'Announcement created');
            goToAnnouncements();
        }
        else {
            setErrors(expand(errors)[1]);
            toast.error('Please fix the errors below');
        }
    });
    React.useEffect(() => {
        if (announcement) {
            setForm(announcement);
        }
    }, [announcement]);
    return _jsx(_Fragment, { children: _jsx(AdminPageLayout, { children: _jsxs("div", { className: "container py-4", children: [_jsxs("h5", { className: "fw-semibold mb-3", children: [props.id ? "Edit" : "Add", " Announcement"] }), _jsx("div", { className: "mb-4", children: _jsxs("div", { className: "d-flex align-items-center gap-2 text-muted small", children: [_jsx("i", { className: "bi bi-arrow-left" }), _jsx(Link, { href: adminRoutes.contentAnnouncements.getURL(), className: "text-decoration-none text-muted", children: "Back to all announcements" })] }) }), _jsx("div", { className: "card shadow-sm border-0 p-4", children: _jsx(AnnouncementAddEdit, { errors: errors, value: formState, onChange: setForm, onCancel: goToAnnouncements, onSubmit: submit }) })] }) }) });
};
export default AdminContentAnnouncementsAddEdit;
